import {
  MarketplaceRoles,
  PaqueryPointRoles,
  StoreRoles,
} from 'constants/roles';

/**
 * Ancho de los selects del form de usuario que dependen del rol elegido; 0 los oculta.
 * Marketplace comparte fila con Tienda en los roles de tienda.
 *
 * Vive fuera de `index.jsx` para poder testearlo: jest no transforma antd/formik-antd,
 * así que importar el componente en un test explota.
 */
const roleFieldCols = (userRoleID) => {
  const isStore = StoreRoles.includes(userRoleID);
  let marketplace = 0;
  if (isStore) {
    marketplace = 12;
  } else if (MarketplaceRoles.includes(userRoleID)) {
    marketplace = 24;
  }
  return {
    marketplace,
    paqueryPoint: PaqueryPointRoles.includes(userRoleID) ? 24 : 0,
    store: isStore ? 12 : 0,
  };
};

export default roleFieldCols;
